/**
 * FASE 20.2 — Prayers Query Adapter
 */

import { supabase }             from "../../supabase";
import { applyPermissionScope } from "../permissionFilters";

// Prayers table uses 'text' (not contact_name) and 'category' (not prayer_type).
// resolved_at column does not exist — use status === "respondida" instead.
const PRAYER_FIELDS = "id, text, category, status, created_at, district_id, church_id";
const MAX_ROWS      = 20;

/**
 * Active/unresolved prayers in the last 14 days.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @returns {Promise<Object[]>}
 */
export async function getRecentPrayers(scope) {
  const fourteenDaysAgo = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString();

  let query = supabase
    .from("prayers")
    .select(PRAYER_FIELDS)
    .gte("created_at", fourteenDaysAgo)
    .order("created_at", { ascending: false })
    .limit(MAX_ROWS);

  query = applyPermissionScope(query, scope);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}
